<div class="text-color-neutral-darkest">{{ 'payroll.deductionTaxation.employeePremium' | translate }}</div>
<div class="app-grid margin-top-2">
    <div class="columns-6">{{ 'payroll.deductionTaxation.income' | translate }}</div>
    <div class="columns-6 text-color-primary">
        {{
            (deductionType?.pretax ? 'payroll.deductionTaxation.preTax' : 'payroll.deductionTaxation.postTax')
                | translate
        }}
    </div>
</div>
<div class="margin-top-3 text-color-neutral">{{ 'payroll.deductionTaxation.taxForms' | translate }}</div>
<div class="app-grid margin-top-2">
    <div class="columns-6">{{ 'payroll.deductionTaxation.t4Boxes' | translate }}</div>
    <div class="columns-6">{{ deductionType?.t4BoxesDisplayList }}</div>
</div>

<ng-container *ngIf="qcPayrollFeatureFlag">
    <div class="app-grid margin-top-2">
        <div class="columns-6">{{ 'payroll.deductionTaxation.rl1Boxes' | translate }}</div>
        <div class="columns-6">{{ deductionType?.rl1BoxesDisplayList }}</div>
    </div>
</ng-container>
